import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonProps, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface CreateTeamButtonProps extends ButtonProps {}

export const CreateTeamButton = React.memo((props: CreateTeamButtonProps) => {
  const { t } = useTranslation()
  return (
    <Button
      variant={ButtonVariant.PRIMARY}
      label={t("Team.Actions.Create")}
      icon={IconName.PLUS_CIRCLE}
      data-testid="team__actions__create"
      {...props}
    />
  )
})
